import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import CameraScannerButton from "@/components/CameraScannerButton";
import { StatusBadge } from "@/components/StatusUI";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Loader2, QrCode, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function QRScan() {
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [found, setFound] = useState(null);

  const resolver = async (payload) => {
    const val = (payload ?? code).trim();
    if (!val) return;
    setBusy(true);
    try {
      const { data } = await api.get(`/pedidos/qr/${encodeURIComponent(val)}`);
      setFound(data);
      toast.success(`${data.numero} localizado`);
    } catch (e) {
      setFound(null);
      toast.error(e.response?.data?.detail || "Pedido não encontrado para este QR");
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-5 max-w-xl mx-auto" data-testid="qr-scan-page">
      <div>
        <div className="text-xs text-primary uppercase tracking-[0.18em] font-bold">Expedição / Embarque / Recebimento</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold uppercase">Ler QR do Volume</h1>
      </div>
      <Card className="bg-card/70 p-4 space-y-3">
        <div className="flex gap-2">
          <Input value={code} onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => e.key === "Enter" && resolver()}
            placeholder="NEXOLOG|PED-..." className="font-mono h-12" data-testid="qr-input" />
          <Button className="h-12" onClick={() => resolver()} disabled={busy} data-testid="qr-buscar">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <QrCode className="w-5 h-5" />}</Button>
          <CameraScannerButton onDetected={(c) => { setCode(c); resolver(c); }} className="h-12 px-4 shrink-0" testid="qr-camera" />
        </div>
        <p className="text-[11px] text-muted-foreground">Aponte a câmera para o QR da etiqueta. Ao ler, o pedido é localizado e você abre a operação correspondente ao seu perfil e à etapa atual.</p>
      </Card>

      {found && (
        <Card className="bg-card/70 p-4 flex items-center justify-between gap-3" data-testid="qr-resultado">
          <div>
            <div className="font-mono font-bold text-lg">{found.numero}{found.tipo === "COMPLEMENTAR" && <span className="text-amber-300 text-xs ml-1">(Compl.)</span>}</div>
            <div className="mt-1"><StatusBadge status={found.status} /></div>
          </div>
          <Button onClick={() => nav(`/pedidos/${found.id}`)} data-testid="qr-abrir"><ArrowRight className="w-4 h-4" /> Abrir Operação</Button>
        </Card>
      )}
    </div>
  );
}
